import { OwnPropsOfRenderer } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { Typography } from '@rossum/ui/material';

type TypographyControlProps = {
  data: { text: string };
} & OwnPropsOfRenderer;

export const TypographyControl = withJsonFormsControlProps(
  ({ data, uischema }: TypographyControlProps) => {
    return <Typography {...uischema?.options}>{data?.text}</Typography>;
  }
);
